import { c as _c } from "react/compiler-runtime";
import type { FunctionComponent, JSX } from 'react';
import * as React from 'react';
import type { PropsWithChildrenRequired } from './types';
interface Props {
  components: Array<React.FunctionComponent<PropsWithChildrenRequired<unknown>>>;
  children: React.ReactNode;
}

/**
 * Simple component that composes components together.
 */
export function Compose(props) {
  const $ = _c(7);
  const {
    components: t0,
    children
  } = props;
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const components = t1;
  let t2;
  if ($[2] !== children || $[3] !== components) {
    t2 = components.reduceRight(_temp, children);
    $[2] = children;
    $[3] = components;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <>{t2}</>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/**
 * Create a container component that composes all of the sub-components together.
 */
function _temp(acc, Component) {
  return <Component>{acc}</Component>;
}
export function createContainer(providers: FunctionComponent<PropsWithChildrenRequired<unknown>>[]) {
  return function Container(props: PropsWithChildrenRequired<unknown>): JSX.Element {
    const {
      children
    } = props;
    return <Compose components={providers}>{children}</Compose>;
  };
}